import { paragraphCss } from "@/styles/typography";
import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components";

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(600px, 100%), 1fr));
  gap: 37px;
  margin-bottom: 34px;

  @media screen and (max-width: 992px) {
    margin-bottom: 18px;
    gap: 14px;
  }
`;

const Video = styled.div`
  width: 100%;
  height: 100%;

  video {
    width: 100%;
    aspect-ratio: 16 / 9;
    object-fit: cover;
    object-position: center;
  }
`;
const S = {
  Container,
  Video,
};

export default S;
